import type { InputProps } from '@presentation/components';

export interface InputStarsFieldProps extends InputProps {
  name: string;
  tooltips?: string[];
}
